<template>
    <div>
        <div style="display: flex; align-items: center" class="text-center thumbnail">
            <div class="col">
                <button @click="toggleShowReasonModal" class="btn">Button</button>
            </div>
            <div class="col" style="padding: 5px">
                {{getIssueFixValue}}
            </div>
        </div>
        <div v-if="showReasonModal" style="z-index:1;border:1px solid #999;background:#fff;position:fixed;top:calc(50% - 100px);left:calc(50% - 180px);width:300px;padding:30px;">
            <h2 class="text-center">What was the outcome:</h2>
            <form @submit.prevent="sendActionReason">
                <div v-if="showValidateMessage">
                    <div class="invalid">Select at list one value</div>
                </div>
                <div class="flex">
                    <h3>
                        <label for="val1">I never reached her</label>
                        <input v-model="form.issue_reason" type="radio" name="issue_reason" id="val1" value="I never reached her" />
                    </h3>
                </div>

                <div class="flex">
                    <h3>
                        <label for="val2">She got a new free box</label>
                        <input v-model="form.issue_reason" type="radio" name="issue_reason" id="val2" value="She got a new free box" />
                    </h3>
                </div>

                <div class="flex">
                    <h3>
                        <label for="val3">We had a talked about her box and I wrote new notes on her</label>
                        <input v-model="form.issue_reason" type="radio" name="issue_reason" id="val3" value="We had a talked about her box and I wrote new notes on her" />
                    </h3>
                </div>

                <div class="flex">
                    <h3>
                        <label for="val4">She did not want to talk</label>
                        <input v-model="form.issue_reason" type="radio" name="issue_reason" id="val4" value="She did not want to talk" />
                    </h3>
                </div>
                <div class="row button-group">
                    <button class="btn col">Send</button>
                    <button @click="toggleShowReasonModal" class="btn col">Close</button>
                </div>

            </form>
        </div>
    </div>

</template>

<script>
import Vue from 'vue'

export default {
  name: 'issue-reason-modal',
  props: [
    'order'
  ],
  data: () => ({
    showReasonModal: false,
    showValidateMessage: false,
    saving: false,
    issue_fix: '',
    form: {
      issue_reason: ''
    }
  }),

  computed: {
    getIssueFixValue () {
      return this.order.issue_fix
    }
  },

  methods: {
    toggleShowReasonModal () {
      this.showReasonModal = !this.showReasonModal
    },

    sendActionReason () {
      if (!this.form.issue_reason) {
        this.showValidateMessage = true
      } else {
        this.form.order_id = this.order.order_id

        Vue.api.patch('/order/' + this.order.order_id + '/issue-reason', {
          data: this.form
        }, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: (res) => {
            this.issue_fix = res.issue_fix
            this.toggleShowReasonModal()
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
    .button-group {
        justify-content: space-between;
        display: flex;
    }

    .invalid {
        color: red;
        border: 1px solid;
        padding: 10px;
    }
</style>
